/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
// eslint-disable-next-line quotes
// import Swiper, {
//   Autoplay,
//   Navigation,
//   Pagination,
//   Thumbs,
//   EffectFade,
//   // eslint-disable-next-line quotes
// } from "swiper";

// Swiper.use([Autoplay, Navigation, Pagination, Thumbs, EffectFade]);
export default {
  init() {
    // function SlideIt() {
    //   clearInterval(myInterval);
    //   if (swiper.slides.length - 1 === swiper.activeIndex) {
    //     swiper.slideTo(0);
    //   } else {
    //     swiper.slideNext();
    //   }
    // }
    // const getPlayerInstance = function (tindex) {
    //   const playerDom = $("video")[tindex];
    //   const id = $(playerDom).attr("id");
    //   return videojs.getPlayer(id);
    // };
    // for (i = 0; i < $("video").length; i++) {
    //   const tplayer = getPlayerInstance(i);
    //   if (i > 0) {
    //     tplayer.currentTime(0);
    //     tplayer.pause();
    //   }
    //   tplayer.on("ended", function () {
    //     if (Swiper().slides.length - 1 === Swiper().activeIndex) {
    //       Swiper().slideTo(0);
    //     } else {
    //       Swiper().slideNext();
    //     }
    //   });
    // }
    // eslint-disable-next-line quotes, no-undef
    // new Swiper(".banner-slide", {
    //   // grabCursor: true,
    //   // speed: 500,
    //   loop: true,
    //   // autoplay: {
    //   //   delay: 5000,
    //   // },
    //   // Optional parameters
    //   // eslint-disable-next-line quotes
    //   direction: "horizontal",
    //   // loop: false,
    //   navigation: {
    //     // eslint-disable-next-line quotes
    //     nextEl: ".slider__button-next",
    //     // eslint-disable-next-line quotes
    //     prevEl: ".slider__button-prev",
    //   },
    //   on: {
    //     transitionStart: function () {
    //       var videos = document.querySelectorAll("video");
    //       for (let i = 0; i < videos.length; i++) {
    //         if (i > 0) {
    //           videos(0).play();
    //         }
    //       }
    //       // eslint-disable-next-line quotes
    //       Array.prototype.forEach.call(videos, function (video) {
    //         video.pause();
    //       });
    //     },
    //     transitionEnd: function () {
    //       var activeIndex = this.activeIndex;
    //       var activeSlide =
    //         // eslint-disable-next-line quotes
    //         document.getElementsByClassName("swiper-slide")[activeIndex];
    //       // eslint-disable-next-line quotes
    //       var activeSlideVideo = activeSlide.getElementsByTagName("video")[0];
    //       activeSlideVideo.play();
    //     },
    //   },
    // });
    // $(document).ready(function () {
    //   let myInterval = 0;
    //   const swiper = new Swiper(".mySwiper", {
    //     autoplay: false,
    //     spaceBetween: 30,
    //     centeredSlides: true,
    //     navigation: {
    //       // eslint-disable-next-line quotes
    //       nextEl: ".slider__button-next",
    //       // eslint-disable-next-line quotes
    //       prevEl: ".slider__button-prev",
    //     },
    //   });
    //   const getPlayerInstance = function (tindex) {
    //     const playerDom = $("video")[tindex];
    //     const id = $(playerDom).attr("id");
    //     return video.getPlayer(id);
    //   };
    //   function SlideIt() {
    //     clearInterval(myInterval);
    //     if (swiper.slides.length - 1 === swiper.activeIndex) {
    //       swiper.slideTo(0);
    //     } else {
    //       swiper.slideNext();
    //     }
    //   }
    //   for (let i = 0; i < $("video").length; i++) {
    //     const tplayer = getPlayerInstance(i);
    //     if (i > 0) {
    //       tplayer.currentTime(0);
    //       tplayer.pause();
    //     }
    //     tplayer.on("ended", function () {
    //       SlideIt();
    //     });
    //   }
    //   swiper.on("slideChange", function (e) {
    //     const slide = swiper.slides[swiper.activeIndex];
    //     if ($(slide).find(".overlayVideo").length > 0) {
    //       const activePlayer = video($(slide).find(".overlayVideo").attr("id"));
    //       activePlayer.currentTime(0);
    //       activePlayer.play();
    //     } else {
    //       myInterval = setInterval(SlideIt, 5000);
    //     }
    //   });
    // });
    // $(document).ready(function () {
    //   var windowHeight = $(window).height();
    //   var topMenuHeight = $(".top-menu").height();
    //   $("ss3-fullpage").css("--target-height", windowHeight - topMenuHeight);
    //   // $(".section-banner .swiper-slide").css(
    //   //   "height",
    //   //   windowHeight - topMenuHeight
    //   // );
    // });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js